import Image from "next/image";
import styles from "./styles/voice-card.module.scss";
import VoiceInfo from "@/components/pages/home/components/voices/voice-info";
import VoiceTopInfo from "@/components/pages/home/components/voices/voice-top-info";
import { VoiceModel } from "@/actions/db/get-models";
import defaultIcon from "@/assets/models/default.webp";
import { useGlobalModalContext } from "@/providers/modal-provider/modal-provider";
import { useImageErrorHandler } from "@/hooks/use-image-error-handler";

export type VoiceCardProps = {
  model: VoiceModel;
  handleVoiceModelClick: (model: VoiceModel) => void;
};

/**
 * Voice card
 * Should change width and height properties in <VirtualizedVoicesGrid> also if card style will be changed because virtualization need a tsx sizes set.
 */
const VoiceCard = ({ model, handleVoiceModelClick }: VoiceCardProps) => {
  const { hideModal } = useGlobalModalContext();

  const { currentIcon, handleImageError } = useImageErrorHandler(
    model.thumbnail || defaultIcon,
    defaultIcon,
  );

  const handleClick = () => {
    hideModal();
    handleVoiceModelClick(model);
  };

  return (
    <div className={styles.card}>
      <div key={model.id} onClick={handleClick} className={styles.artist_image}>
        <Image
          className={styles.image}
          src={currentIcon}
          onError={handleImageError}
          alt={model.name}
          fill
          loading="lazy"
          quality={75}
        />
      </div>
      <VoiceTopInfo
        modelId={model.id}
        isHot={true}
        isFavouriteModel={(model as VoiceModel).isFavourite}
        usesCount={model.usageCount || undefined}
        handleClick={handleClick}
      />
      <VoiceInfo
        title={model.name}
        url={model.audioPreviewUrl || undefined}
        handleClick={handleClick}
      />
    </div>
  );
};

export default VoiceCard;
